export const AVAILABLE_MODULES = [
  "Dashboard",
  "Invite",
  "Role",
  "Payment",
  "Communication",
  "AdminReport",
  "TenantReport",
  "Community",
  "Designation",
  "Logo",
  "DocumentManagement",
  "PropertyDetails",
  "PropertyApproval",
  "EVoting",
];

